export default __webpack_public_path__ + "static/dont-focus-after-motion-88b38201dc9829216140ed38c8575460.png";